/* Problem Section — scroll-driven research chart.
   Draws a data line as the section pins, pans it right, reveals each finding as
   the line reaches it, and dissolves older findings off the left edge. */
(function () {
  function initChart(root) {
    const plane = root.querySelector('[data-plane]');
    const path = root.querySelector('[data-path]');
    const tip = root.querySelector('[data-tip]');
    const points = [].slice.call(root.querySelectorAll('[data-point]'));
    const stats = [].slice.call(root.querySelectorAll('[data-stat]'));
    const counter = root.querySelector('[data-counter]');
    const yearEl = root.querySelector('[data-year]');
    const counterBox = root.querySelector('[data-counter-box]');
    const viewport = root.querySelector('.dreamey-problem__viewport');
    const sticky = root.querySelector('.dreamey-problem__sticky');
    const readout = root.querySelector('[data-readout]');
    const readoutNumber = root.querySelector('[data-readout-number]');
    const readoutLabel = root.querySelector('[data-readout-label]');

    if (!plane || !path || !points.length) return;

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const isSmall = () => window.matchMedia('(max-width: 991px)').matches;

    // Finding copy + year labels are the single source of truth in the DOM
    const findings = stats.map(function (el) {
      return {
        number: el.querySelector('.dreamey-data-number').textContent,
        label: el.querySelector('.dreamey-data-label').textContent,
        year: el.getAttribute('data-year') || ''
      };
    });
    let readoutIdx = -1;

    // Counter sits at the chart's bottom-right corner, out of the data's way
    function alignCounter() {
      if (!counterBox) return;
      const st = sticky.getBoundingClientRect();
      const vp = viewport.getBoundingClientRect();
      counterBox.style.top = (vp.bottom - st.top - counterBox.offsetHeight) + 'px';
      counterBox.style.right = (st.right - vp.right) + 'px';
      counterBox.style.visibility = 'visible';
    }

    const pathLen = path.getTotalLength();
    path.style.strokeDasharray = pathLen;

    // Length along the path at which each data point sits (binary scan, once)
    const pointLens = points.map(function (pt) {
      const targetX = +pt.getAttribute('cx');
      let lo = 0, hi = pathLen;
      for (let i = 0; i < 24; i++) {
        const mid = (lo + hi) / 2;
        if (path.getPointAtLength(mid).x < targetX) lo = mid; else hi = mid;
      }
      return (lo + hi) / 2;
    });

    function render(progress) {
      // Line completes slightly before the pin releases, then holds a beat
      const eased = Math.min(1, progress * 1.06);
      const drawLen = pathLen * eased;
      path.style.strokeDashoffset = pathLen - drawLen;

      // Tip rides the end of the drawn line
      const tipPt = path.getPointAtLength(drawLen);
      if (tip) tip.setAttribute('transform', 'translate(' + tipPt.x + ',' + tipPt.y + ')');

      // Pan the plane so the tip stays in view
      const planeW = plane.offsetWidth;
      const viewW = viewport.offsetWidth;
      const maxPan = Math.max(0, planeW - viewW);
      plane.style.transform = 'translateX(' + (-maxPan * eased) + 'px)';

      const small = isSmall();
      let revealed = 0;
      pointLens.forEach(function (len, i) {
        const on = drawLen >= len - 1;
        points[i].classList.toggle('is-on', on);
        stats[i].classList.toggle('is-on', on);
        if (on) revealed = i + 1;

        // Dissolve a finding as its data point nears the left edge, so old
        // findings fade cleanly instead of leaving clipped word fragments.
        if (on && !small) {
          const cx = +points[i].getAttribute('cx');
          const screenX = (cx / 2400) * planeW - maxPan * eased;
          const fadeZone = 70;
          stats[i].style.opacity = screenX < fadeZone
            ? Math.max(0, screenX / fadeZone).toFixed(3)
            : '';
        } else {
          stats[i].style.opacity = '';
        }
      });

      const idx = Math.max(0, revealed - 1);
      if (counter) counter.textContent = 'FINDING 0' + Math.max(1, revealed);
      if (yearEl && findings[idx]) yearEl.textContent = findings[idx].year;

      // Mobile readout: swap to the latest finding with a small entrance
      if (idx !== readoutIdx && readout && findings[idx]) {
        readoutIdx = idx;
        readoutNumber.textContent = findings[idx].number;
        readoutLabel.textContent = findings[idx].label;
        readout.classList.remove('tick');
        void readout.offsetWidth; // restart animation
        readout.classList.add('tick');
      }
    }

    if (reduced) {
      root.classList.add('is-static'); // unpin, show static list
      return;
    }
    alignCounter();

    let ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        alignCounter();
        const rect = root.getBoundingClientRect();
        const scrollable = root.offsetHeight - window.innerHeight;
        const progress = scrollable > 0
          ? Math.min(1, Math.max(0.02, -rect.top / scrollable))
          : 0.02;
        render(progress);
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { alignCounter(); onScroll(); }, { passive: true });
    onScroll();
  }

  function init() {
    document.querySelectorAll('.dreamey-problem').forEach(initChart);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
